<template>
	<div>
		<a-button type="primary" class="primary" size="small" @click="showPaiche">
			{{ $t('businessDispatch.dispatch') }}
		</a-button>
		<a-modal :title="$t('businessDispatch.dispatch')" :visible="visible_paiche" @cancel="cancelPaiche">
			<a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-item :label="$t('businessDispatch.plateNumber')">
					<a-select
						show-search
						allowClear
						style="width: 150px"
						v-model="form_paiche.truckId"
						:placeholder="$t('businessDispatch.pleaseSelectPlateNumber')"
						:filter-option="filterOption"
						@change="changeTruck"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.pleaseSelectPlateNumber') }],
							},
						]"
					>
						<template v-for="(item, index) in truckList">
							<a-select-option :value="item.id" :key="index">
								{{ item.plateNumber }}
							</a-select-option>
						</template>
					</a-select>
				</a-form-item>
				<a-form-item :label="$t('businessDispatch.driver')">
					<a-select
						show-search
						allowClear
						v-model="form_paiche.driverId"
						style="width: 150px"
						:placeholder="$t('businessDispatch.pleaseSelectDriverName')"
						:filter-option="filterOption"
						@change="changeDriver"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.pleaseSelectDriverName') }],
							},
						]"
					>
						<template v-for="item in driverList">
							<a-select-option :key="item.id">
								{{ item.name }}
							</a-select-option>
						</template>
					</a-select>
				</a-form-item>
			</a-form>
			<template slot="footer" class="footer_paiche">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_paiche"
					@click="okPaiche"
				>
					{{ $t('businessDispatch.designate') }}
				</a-button>
				<a-button key="back" @click="resetPaiche">
					{{ $t('reset') }}
				</a-button>
			</template>
		</a-modal>
	</div>
</template>
<script>
import { assignDriver } from "../../api/business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";
import { trucklist, driverlist } from "../../api/basicData";

export default {
	name: "paiche",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			req: searchReqParam(),
			truckList: [],
			driverList: [],
			visible_paiche: false,
			confirmLoading_paiche: false,
			form_paiche: {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			},
		};
	},
	mounted() {
		this.pageInit();
	},
	methods: {
		pageInit() {
			trucklist(this.req).then((res) => {
				this.truckList = JSON.parse(res.data).data.list;
			});
			driverlist(this.req).then((res) => {
				this.driverList = JSON.parse(res.data).data.list;
			});
		},
		filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
		showPaiche() {
			if (this.selectedRows.length >= 1) {
				if (this.selectedRows[0].orderStatus.code == "CANCELLED") {
					this.$message.error(this.$t('businessDispatch.unableToDispatchCar'));
					return;
				}
				// // 如果已经派车,回显司机和货车
				this.driverList.forEach((item) => {
					if (item.name == this.selectedRows[0].driverName) {
						console.log(item.name, this.selectedRows[0].driverName, item.id);
						this.form_paiche.driverId = item.id;
						this.form_paiche.driver = item;
					}
				});
				this.truckList.forEach((item) => {
					if (item.plateNumber == this.selectedRows[0].truck) {
						this.form_paiche.truckId = item.id;
						this.form_paiche.truck = item;
					}
				});

				this.visible_paiche = true;
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		cancelPaiche() {
			this.visible_paiche = false;
			this.form_paiche = {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			};
		},
		okPaiche(e) {
			console.log(e);
			// 封装派车请求参数
			let params = {};
			// 司机信息
			params.driverId = this.form_paiche.driverId;
			params.driverName = this.form_paiche.driver.name;
			params.driverPhone = this.form_paiche.driver.mobile;
			// 车辆信息
			params.truckId = this.form_paiche.truckId;
			params.truck = this.form_paiche.truck.plateNumber;
			// 订单号
			params.orderId =
				this.selectedRows.length >= 1 ? this.selectedRows[0].orderId : "";

			// 重新封装请求参数
			this.req.params = params;
			if (params.truckId == "" || params.truckId == undefined) {
				this.$message.error(this.$t('businessDispatch.plateNumberCannotBeEmpty'));
				return;
			}
			if (params.driverName == "") {
				this.$message.error(this.$t('businessDispatch.driverNameCannotBeEmpty'));
				return;
			}
			this.confirmLoading_paiche = true;
			assignDriver(this.req).then((res) => {
				// console.log(JSON.parse(res.data));
				let result = JSON.parse(res.data);
				if (result.code == "0") {
					// 成功提示信息
					this.$message.success(result.msg);
					// 重置
					this.emptypaiche();
					// 通知父单元成功消息
					this.$emit("success", result.msg);
				}
			});
		},
		emptypaiche() {
			// 重置
			this.visible_paiche = false;
			this.resetPaiche();
			this.confirmLoading_paiche = false;
		},
		resetPaiche() {
			this.form_paiche = {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			};
		},
		changeDriver(value, option) {
			console.log(value, option);
			if (!value) {
				this.form_paiche.driver = {
					name: "",
					mobile: "",
				};
			} else {
				this.form_paiche.driver = this.driverList.find((item) => {
					return value == item.id;
				});
			}
			console.log(this.form_paiche.driverId, this.form_paiche.driver);
		},
		changeTruck(value, option) {
			console.log(value, option);
			if (!value) {
				this.form_paiche.truck = {
					plateNumber: "",
				};
			} else {
				this.form_paiche.truck = this.truckList.find((item) => {
					return value == item.id;
				});
			}
			console.log(this.form_paiche.driverId, this.form_paiche.driver);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/.ant-form-item-label > label::before {
	content: "*";
	position: relative;
	top: -0.5px;
	margin: 0 8px 0 2px;
	color: red;
}
</style>
